
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-me",
      function () {
        return require("private-next-pages/about-me.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-me"])
      });
    }
  